import { formatCoordinate } from './coordinate-format';

export { COORDINATE_DISPLAY_DECIMALS, formatCoordinate } from './coordinate-format';

export function formatPrice(price: number | null): string {
  if (price == null) return '\u2014';
  return price.toLocaleString('pl-PL') + ' PLN';
}

export function formatArea(area: number | null): string {
  if (area == null) return '\u2014';
  return area.toLocaleString('pl-PL', { maximumFractionDigits: 2 }) + ' m\u00B2';
}

export function formatDimensions(w: number | null, h: number | null): string {
  if (w == null || h == null) return '\u2014';
  return `${w} \u00D7 ${h} m`;
}

export function formatAudienceEstimate(val: number | null): string {
  if (val == null) return '\u2014';
  return val.toLocaleString('pl-PL', { maximumFractionDigits: 0 });
}

/**
 * Returns a partial dimension string when at least one axis is provided.
 * Returns null only when both w and h are null (caller renders '—').
 */
export function formatPartialDimensions(w: number | null, h: number | null): string | null {
  if (w == null && h == null) return null;
  if (w != null && h != null) return `${w} \u00D7 ${h} m`;
  if (w != null) return `${w} m`;
  return `${h} m`;
}

/**
 * Formats a latitude/longitude pair as "lat, lng" with uniform fixed decimals.
 * Returns '—' when either axis is null/undefined.
 */
export function formatCoordinatePair(
  latitude: number | null | undefined,
  longitude: number | null | undefined,
): string {
  if (latitude == null || longitude == null) return '\u2014';
  return `${formatCoordinate(latitude)}, ${formatCoordinate(longitude)}`;
}

export function capitalize(str: string | null): string {
  if (!str) return '\u2014';
  return str.charAt(0).toUpperCase() + str.slice(1);
}
